// File#: _2_zone-search
// Zone search with MapLibre GL map integration
import { Map, Marker, Popup, LngLatBounds } from 'maplibre-gl';
import 'maplibre-gl/dist/maplibre-gl.css';

(function () {
    var mapElement = document.getElementById('zone-map');
    if (!mapElement) return;

    var config = window.adarZoneConfig || {};
    var restUrl = config.restUrl || '/wp-json/adar/v1/zones/';

    // Parse zones data from DOM
    var zonesData = [];
    try {
        zonesData = JSON.parse(mapElement.getAttribute('data-zones') || '[]');
    } catch (e) {
        console.warn('Zone search: impossible de parser les données zones');
    }

    // Elements
    var postalCodeInput = document.getElementById('zone-postal-code');
    var communeSelect = document.getElementById('zone-commune');
    var cardsGrid = document.querySelector('.zone-cards-grid');
    var cards = cardsGrid ? cardsGrid.querySelectorAll('.zone-card') : [];

    // State
    var map = null;
    var markers = {};
    var popups = {};
    var activeCard = null;
    var activePopup = null;
    var debounceTimer = null;

    // ---- MapLibre init ----
    function initMap() {
        map = new Map({
            container: 'zone-map',
            style: {
                version: 8,
                sources: {
                    osm: {
                        type: 'raster',
                        tiles: ['https://tile.openstreetmap.org/{z}/{x}/{y}.png'],
                        tileSize: 256,
                        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
                    },
                },
                layers: [
                    {
                        id: 'osm',
                        type: 'raster',
                        source: 'osm',
                    },
                ],
            },
            center: [-1.5, 47.2],
            zoom: 7,
            scrollZoom: false,
        });

        var bounds = new LngLatBounds();
        var hasValidCoords = false;

        zonesData.forEach(function (zone) {
            if (!zone.lat || !zone.lng) return;

            // Custom marker element
            var el = document.createElement('div');
            el.className = 'zone-marker';
            el.innerHTML = '<span class="zone-marker__pin"><svg viewBox="0 6 29 26" fill="white" xmlns="http://www.w3.org/2000/svg"><path d="M10.1392 24.5511V31.8826H15.2037V26.7311C13.2291 26.6957 11.4446 25.8712 10.1392 24.5511Z"/><path d="M8.04545 20.3834C7.9466 20.3707 7.84267 20.3986 7.76663 20.4744L2.13938 26.0887C2.00758 26.2202 2.00758 26.4352 2.13938 26.5692L5.31802 29.7431C5.44982 29.8746 5.66528 29.8746 5.79963 29.7431L10.5879 24.9684C9.25962 23.8278 8.32935 22.2169 8.04799 20.3859Z"/><path d="M7.95418 19.1973C7.95418 18.2894 8.11134 17.4169 8.40031 16.6127C8.36735 16.6026 8.3344 16.5925 8.29891 16.5925H0.339662C0.152088 16.5925 0 16.7442 0 16.9314V21.4177C0 21.6049 0.152088 21.7566 0.339662 21.7566H8.29891C8.32933 21.7566 8.35721 21.7465 8.3851 21.7389C8.10627 20.9448 7.95418 20.09 7.95418 19.1973Z"/><path d="M8.05306 17.9657C8.34709 16.1449 9.2799 14.5415 10.6107 13.4085L5.79963 8.60857C5.66782 8.47706 5.45236 8.47706 5.31802 8.60857L2.13938 11.7799C2.00758 11.9114 2.00758 12.1263 2.13938 12.2604L7.76663 17.8747C7.8452 17.9531 7.95167 17.9784 8.05306 17.9657Z"/><path d="M15.2037 11.6661V6.48171H10.4788C10.2912 6.47666 10.1392 6.62839 10.1392 6.81554V13.846C11.4446 12.5259 13.2291 11.7015 15.2037 11.6661Z"/><path d="M15.2061 31.875C18.0476 31.751 21.3555 30.2843 23.1628 28.1523V31.1112H28.4123V7.29098H23.1628V10.2929H23.0791C22.8611 9.95144 22.4733 9.56451 22.2148 9.30656C20.2883 7.55652 17.8144 6.48677 15.2061 6.47666V11.661C15.2948 11.656 15.4671 11.661 15.5584 11.661C19.6369 11.661 22.9651 15.022 22.9651 19.1847C22.9651 23.3473 19.6242 26.7311 15.5457 26.7311C15.4545 26.7311 15.2948 26.7361 15.2061 26.7311V31.8826V31.875Z"/></svg></span>';

            // Popup
            var popupContent = '<div class="zone-popup">';
            if (zone.thumbnail) {
                popupContent += '<img src="' + zone.thumbnail + '" alt="' + zone.title + '" class="zone-popup__image">';
            }
            popupContent += '<strong class="zone-popup__title">' + zone.title + '</strong>';
            popupContent += '<a href="' + zone.link + '" class="zone-popup__link">Voir l\'agence</a>';
            popupContent += '</div>';

            var popup = new Popup({ offset: 20, closeButton: false, focusAfterOpen: false }).setHTML(popupContent);

            var marker = new Marker({ element: el, anchor: 'center' })
                .setLngLat([zone.lng, zone.lat])
                .setPopup(popup)
                .addTo(map);

            el.addEventListener('click', function () {
                highlightCard(zone.id);
            });

            markers[zone.id] = marker;
            popups[zone.id] = popup;
            bounds.extend([zone.lng, zone.lat]);
            hasValidCoords = true;
        });

        if (hasValidCoords) {
            map.fitBounds(bounds, { padding: 50, maxZoom: 10 });
        }
    }

    // ---- Card highlight ----
    function highlightCard(zoneId) {
        if (activeCard) {
            activeCard.classList.remove('zone-card--active');
        }

        var card = cardsGrid.querySelector('.zone-card[data-zone-id="' + zoneId + '"]');
        if (!card) return;

        card.classList.add('zone-card--active');
        activeCard = card;
    }

    function focusZoneOnMap(zoneId) {
        var marker = markers[zoneId];
        if (!marker || !map) return;

        // Close any open popup
        if (activePopup) {
            activePopup.remove();
        }

        var lngLat = marker.getLngLat();
        map.flyTo({ center: lngLat, zoom: 12 });

        marker.togglePopup();
        activePopup = popups[zoneId];
    }

    // ---- Search ----
    function fetchCommunes(postalCode) {
        communeSelect.disabled = true;
        communeSelect.innerHTML = '<option value="">Chargement...</option>';

        fetch(restUrl + 'communes?postal_code=' + encodeURIComponent(postalCode))
            .then(function (response) {
                return response.json();
            })
            .then(function (data) {
                communeSelect.innerHTML = '<option value="">Votre commune</option>';

                if (!data || data.length === 0) {
                    communeSelect.innerHTML = '<option value="">Aucune commune trouvée</option>';
                    return;
                }

                data.forEach(function (item) {
                    var option = document.createElement('option');
                    option.value = item.commune;
                    option.textContent = item.commune;
                    communeSelect.appendChild(option);
                });

                communeSelect.disabled = false;

                // Auto-select if only one commune
                if (data.length === 1) {
                    communeSelect.value = data[0].commune;
                    searchZone(postalCode, data[0].commune);
                }
            })
            .catch(function () {
                communeSelect.innerHTML = '<option value="">Erreur de chargement</option>';
            });
    }

    function searchZone(postalCode, commune) {
        fetch(restUrl + 'search?postal_code=' + encodeURIComponent(postalCode) + '&commune=' + encodeURIComponent(commune))
            .then(function (response) {
                if (!response.ok) return null;
                return response.json();
            })
            .then(function (data) {
                if (!data) return;

                var zoneId = data.zone_id || (Array.isArray(data) && data[0] ? data[0].zone_id : null);
                if (!zoneId) return;

                highlightCard(zoneId);
                focusZoneOnMap(zoneId);
            });
    }

    // ---- Events ----
    if (postalCodeInput) {
        postalCodeInput.addEventListener('input', function () {
            var value = this.value.replace(/\D/g, '');
            this.value = value;

            clearTimeout(debounceTimer);

            if (value.length === 5) {
                debounceTimer = setTimeout(function () {
                    fetchCommunes(value);
                }, 300);
            } else {
                communeSelect.disabled = true;
                communeSelect.innerHTML = '<option value="">Votre commune</option>';
            }
        });
    }

    if (communeSelect) {
        communeSelect.addEventListener('change', function () {
            var commune = this.value;
            var postalCode = postalCodeInput ? postalCodeInput.value : '';

            if (commune && postalCode.length === 5) {
                searchZone(postalCode, commune);
            }
        });
    }

    // Card click → zoom on map
    cards.forEach(function (card) {
        card.addEventListener('click', function (e) {
            if (e.target.tagName === 'A') return;
            var zoneId = parseInt(card.getAttribute('data-zone-id'), 10);
            if (zoneId) {
                highlightCard(zoneId);
                focusZoneOnMap(zoneId);
            }
        });
    });

    // ---- Init ----
    initMap();
})();
